/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Url_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't read that link. Use a share link from vdb.im, vtesdecks.com or Amaranth, or switch to Paste, which always works." |
*
* @param {Deck_Url_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_url_import_failed = /** @type {((inputs?: Deck_Url_Import_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Url_Import_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de lire ce lien. Utilisez un lien de partage vdb.im, vtesdecks.com ou Amaranth, ou passez à Coller, qui marche toujours.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo leer ese enlace. Use un enlace para compartir de vdb.im, vtesdecks.com o Amaranth, o pase a Pegar, que siempre funciona.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível ler esse link. Use um link de compartilhamento do vdb.im, vtesdecks.com ou Amaranth, ou mude para Colar, que sempre funciona.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile leggere quel link. Usa un link di condivisione di vdb.im, vtesdecks.com o Amaranth, o passa a Incolla, che funziona sempre.")
	return /** @type {LocalizedString} */ ("Couldn't read that link. Use a share link from vdb.im, vtesdecks.com or Amaranth, or switch to Paste, which always works.")
});